var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFoundItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_416_3769)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    clipPath: "url(#clip1_416_3769)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_416_3769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.55292 58.2352C3.55292 52.3485 8.32504 47.5764 14.2117 47.5764H99.4823C105.369 47.5764 110.141 52.3485 110.141 58.2352V129.294C110.141 135.181 105.369 139.953 99.4823 139.953H14.2118C8.32504 139.953 3.55292 135.181 3.55292 129.294V58.2352Z",
    fill: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.55292 58.2352C3.55292 52.3485 8.32504 47.5764 14.2117 47.5764H99.4823C105.369 47.5764 110.141 52.3485 110.141 58.2352V129.294C110.141 135.181 105.369 139.953 99.4823 139.953H14.2118C8.32504 139.953 3.55292 135.181 3.55292 129.294V58.2352Z",
    stroke: "#1F2024",
    strokeWidth: 3.55294
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_416_3769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9647 58.2352C47.9647 52.3485 52.7368 47.5764 58.6235 47.5764H136.788C142.675 47.5764 147.447 52.3485 147.447 58.2352V129.294C147.447 135.181 142.675 139.953 136.788 139.953H58.6235C52.7368 139.953 47.9647 135.181 47.9647 129.294V58.2352Z",
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.9647 58.2352C47.9647 52.3485 52.7368 47.5764 58.6235 47.5764H136.788C142.675 47.5764 147.447 52.3485 147.447 58.2352V129.294C147.447 135.181 142.675 139.953 136.788 139.953H58.6235C52.7368 139.953 47.9647 135.181 47.9647 129.294V58.2352Z",
    stroke: "#1F2024",
    strokeWidth: 3.55294
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.812 49.3529H121.688L96.8176 138.176H79.9412L104.812 49.3529Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.15 49.3529H100.815L75.9441 138.176H73.2794L98.15 49.3529Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.243,
    y1: 100,
    x2: 144,
    y2: 108.757,
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddi_416_3769)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.4,
    y: 69.7823,
    width: 74.6118,
    height: 28.4235,
    rx: 7.10588,
    fill: "#1F2024"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.1647,
    cy: 83.9941,
    r: 7.10588,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.247,
    cy: 83.9941,
    r: 7.10588,
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 22.2059,
    cy: 99.9824,
    r: 15.9882,
    fill: "#1F2024",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_416_3769)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.7618,
    cy: 95.097,
    r: 15.9882,
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 21.7618,
    cy: 95.097,
    r: 15.9882,
    stroke: "#1F2024",
    strokeWidth: 3.55294
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2029 84.4382C27.8197 85.2988 29.2018 86.6918 30.2 88.4353",
    stroke: "white",
    strokeWidth: 3.55294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_416_3769)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.8794,
    cy: 95.0971,
    r: 10.6588,
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12.8794,
    cy: 95.0971,
    r: 10.6588,
    stroke: "#1F2024",
    strokeWidth: 3.55294
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 80,
    r: 23.5,
    stroke: "black",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ddi_416_3769)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_416_3769)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 107,
    width: 32,
    height: 7,
    rx: 3.5,
    fill: "#1F2024"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 107,
    width: 5.32941,
    height: 14.2118,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.8823,
    y: 107,
    width: 5.32941,
    height: 14.2118,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7647,
    y: 107,
    width: 5.32941,
    height: 14.2118,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.647,
    y: 107,
    width: 5.32941,
    height: 14.2118,
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 107,
    width: 32,
    height: 7,
    rx: 3.5,
    stroke: "#1F2024",
    strokeWidth: 2.66471
  })), /*#__PURE__*/React.createElement("rect", {
    x: 75.0559,
    y: 25.8147,
    width: 0.888235,
    height: 16.4324,
    fill: "#EEEEEE",
    stroke: "#1F2024",
    strokeWidth: 3.55294
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 25.3706,
    r: 5.32941,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9589 29.8117C55.9589 19.0194 64.7077 10.2705 75.5 10.2705C86.2923 10.2705 95.0412 19.0194 95.0412 29.8117V42.247H55.9589V29.8117Z",
    fill: "white",
    fillOpacity: 0.5,
    stroke: "#1F2024",
    strokeWidth: 3.55294
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_416_3769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6294 45.8C50.6294 43.8378 52.2201 42.2471 54.1823 42.2471H96.8176C98.7799 42.2471 100.371 43.8378 100.371 45.8V47.5765H50.6294V45.8Z",
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.6294 45.8C50.6294 43.8378 52.2201 42.2471 54.1823 42.2471H96.8176C98.7799 42.2471 100.371 43.8378 100.371 45.8V47.5765H50.6294V45.8Z",
    stroke: "#1F2024",
    strokeWidth: 3.55294
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_416_3769",
    x: 1.77643,
    y: 45.7999,
    width: 110.141,
    height: 95.9294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -7.10588
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_416_3769"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.10588
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_416_3769",
    result: "effect2_innerShadow_416_3769"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_416_3769",
    x: 46.1882,
    y: 45.7999,
    width: 103.035,
    height: 95.9294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10.6588,
    dy: 3.55294
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_416_3769"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddi_416_3769",
    x: 58.6236,
    y: 69.7823,
    width: 78.1647,
    height: 28.4236,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.77647
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_416_3769"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.77647
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_416_3769",
    result: "effect2_dropShadow_416_3769"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_416_3769",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.77647
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_416_3769"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_416_3769",
    x: 3.99707,
    y: 77.3323,
    width: 35.5294,
    height: 35.5294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.32941,
    dy: -3.55294
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_416_3769"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_416_3769",
    x: 0.444092,
    y: 82.6617,
    width: 24.8706,
    height: 24.8706,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.32941,
    dy: -3.55294
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_416_3769"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ddi_416_3769",
    x: 78.8912,
    y: 105.668,
    width: 38.2176,
    height: 9.66479,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.77647
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_416_3769"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.77647
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_416_3769",
    result: "effect2_dropShadow_416_3769"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_416_3769",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.77647
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_416_3769"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_416_3769",
    x: 48.8529,
    y: 40.4706,
    width: 53.2941,
    height: 8.88232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10.6588,
    dy: 3.55294
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_416_3769"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_416_3769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151,
    height: 151,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_416_3769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151,
    height: 151,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_416_3769"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 107,
    width: 32,
    height: 7,
    rx: 3.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundItem);
export default __webpack_public_path__ + "static/media/not_found_item.c358963b1744182d0861d148ab24f9ce.svg";
export { ForwardRef as ReactComponent };